<template>
  <div style="width: 100%">
    <Breadcrumb></Breadcrumb>
    <div class="withdrawal line-height-40">
      <!-- <el-row class="title">
                <el-col >账户信息</el-col>
            </el-row>
            <el-row :span="24" :xs="24" class="message">
                <div>我的账户：<span>{{ user.p_ope_no }}</span></div>
                <div>账户余额：<span style="color: #f05f6b;">{{ user.balance }}</span> 元</div>
            </el-row> -->
      <div class="common-limit">
        <el-card style="margin: 0 0 12px 0" header="账号信息">
          <div class="message">
            <div>
              我的账户：<span>{{ user.userName }}</span>
            </div>
            <div>
              账户余额：<span style="color: #f05f6b">{{ user.balance }}</span>
              元
            </div>
          </div>
        </el-card>
        <el-card style="margin: 0 0 12px 0">
          <el-form label-position="right" label-width="100px">
            <el-form-item label="提现方式：">
              <el-radio-group
                v-model="withdrawType"
                @change="handleWidthDrawTypeChange"
              >
                <!-- <template v-for="(value, key) in dictData['withdraw_mode']">
                  <el-radio :label="key" :key="key">{{ value }}</el-radio>
                </template> -->
                <el-radio :label="'alipay'">支付宝</el-radio>
                <el-radio :label="'bank'">银行卡</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="姓名：">
              {{ user.nickName }}
            </el-form-item>
            <template v-if="withdrawType === 'alipay'">
              <el-form-item label="支付宝账号：" prop="alipayAccount">
                <el-input
                  style="width: 200px"
                  placeholder="请输入支付宝账号"
                  v-model="saveParams.alipayAccount"
                  clearable
                  size="small"
                  @keyup.enter.native="submitForm"
                />
              </el-form-item>
            </template>
            <template v-else>
              <el-form-item label="银行名称：" prop="bankName">
                <el-input
                  style="width: 200px"
                  placeholder="请输入银行名称"
                  v-model="saveParams.bankName"
                ></el-input>
              </el-form-item>
              <el-form-item label="银行卡号：" prop="bankAccount">
                <el-input
                  style="width: 200px"
                  placeholder="请输入银行卡号"
                  v-model="saveParams.bankAccount"
                ></el-input>
              </el-form-item>
            </template>
            <el-form-item label="提现金额：" prop="amount">
              <el-input
                style="width: 200px; padding-top: -10px; margin: 0 8px 0 0"
                placeholder="请输入金额"
                v-model="saveParams.amount"
                clearable
                size="small"
                maxlength="8"
                onkeyup="this.value=this.value.replace(/[^\d.]/g, '').replace(/^\.{1,}/g,'').replace(/^0{2,}/g,'').match(/^\d*(\.?\d{0,2})/g);"
                @keyup.enter.native="submitForm"
              />
              <el-button @click="choiceAll" type="text">全部提现</el-button>
            </el-form-item>
            <el-form-item label="" prop="amount">
              <span style="color: red"
                >提现金额系统会实时扣款，工作日24小时之内财务完成处理，请知悉！</span
              >
            </el-form-item>
            <el-form-item>
              <el-button type="primary" size="small" @click="submitForm"
                >确认提现</el-button
              >
            </el-form-item>
          </el-form>
        </el-card>
        <el-card>
          <div slot="header">提现记录</div>
          <!-- 表格 -->
          <el-row
            style="
              background-color: white;
              padding: 10px 10px 10px 10px;
              margin-top: -4px;
              line-height: 1;
            "
          >
            <el-col :span="24">
              <template>
                <el-table
                  v-loading="loading"
                  :data="tableData"
                  borderstyle="width: 100%"
                  border
                >
                  <!-- :header-cell-style="{background:'#eef1f6',color:'#595a5a'}"  -->
                  <el-table-column
                    prop="createTime"
                    label="提现时间"
                    align="center"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="amount"
                    label="提现金额"
                    align="center"
                    :formatter="formatter"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="withdrawMode"
                    label="提现方式"
                    align="center"
                    :formatter="formatter"
                  >
                    <template slot-scope="scope">
                      <span>{{
                        dictMap["withdraw_mode"][scope.row.withdrawMode]
                      }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="withdrawId"
                    label="提现账号信息"
                    align="center"
                  >
                    <template slot-scope="scope">
                      <span v-if="scope.row.withdrawMode == '01'">
                        {{ scope.row.account }}/{{ scope.row.name }}
                      </span>
                      <span v-else>
                        {{ scope.row.bankName }}/{{ scope.row.account }}/{{
                          scope.row.name
                        }}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="status" label="状态" align="center">
                    <template slot-scope="scope">
                      <span>{{
                        dictMap["check_status"][scope.row.checkStatus]
                      }}</span>
                    </template>
                  </el-table-column>

                  <el-table-column
                    prop="audit_opinio"
                    label="审核意见"
                    align="center"
                  >
                    <template slot-scope="scope">
                      <span v-if="scope.row.auditOpinion == undefined">--</span>
                      <span v-else>{{ scope.row.auditOpinion }}</span>
                    </template>
                  </el-table-column>
                </el-table>
                <pagination
                  style="margin: 8px 0 0 0"
                  v-show="total > 0"
                  :total="total"
                  :page.sync="queryParams.pageNum"
                  :limit.sync="queryParams.pageSize"
                  @pagination="loadList"
                />
              </template>
            </el-col>
          </el-row>
        </el-card>
      </div>
      <!-- 
        <div class="withdrawal el-main-border" style="margin-top: 25px">
            <el-row class="title" style="border-bottom: 1px solid gainsboro;margin-right: 15px;padding-bottom: 13px;margin-bottom: 20px;">
                <el-col >提现记录</el-col>
            </el-row>
           
        </div> -->
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Breadcrumb from "@/components/common/Breadcrumb";
import { getUserProfile } from "@/api/system/user";
import { listWithdraw, saveWithdraw } from "@/api/system/money";
export default {
  components: { Breadcrumb },
  data() {
    return {
      user: {},
      loading: false,
      total: 0,
      tableData: [],
      dialogFormVisible: false,
      saveParams: {
        amount: "",
        alipayAccount: "",
        bankName: "",
        bankAccount: "",
      },
      queryParams: {
        type: "0",
        pageNum: 1,
        pageSize: 10,
      },

      // 表单校验
      rules: {
        alipayAccount: [
          { required: true, message: "支付宝账号不能为空", trigger: "blur" },
        ],
        amount: [
          { required: true, message: "提现金额不能为空", trigger: "blur" },
        ],
        bankName: [
          { required: true, message: "银行名称不能为空", trigger: "blur" },
        ],
        bankAccount: [
          { required: true, message: "银行卡号不能为空", trigger: "blur" },
        ],
      },
      withdrawType: "alipay",
      isSubmit: false,
    };
  },

  computed: {
    ...mapGetters(["dictData", "dictMap"]),
  },
  created() {
    //查询当前账户余额
    this.getUser();
    //查询提现记录
    this.loadList();
  },
  methods: {
    //格式化提现金额
    formatter(row, column) {
      return row.amount.toFixed(2);
    },
    //查询当前账户余额
    getUser() {
      getUserProfile({}).then((response) => {
        this.user = response.user;
        this.user.balance = this.user.balance.toFixed(2);
      });
    },
    //获取当前账号查询提现记录
    loadList() {
      listWithdraw(this.queryParams).then((response) => {
        this.tableData = response.rows;
        this.total = response.total;
        this.loading = false;
      });
    },
    //提现
    async submitForm() {
      try {
        if (this.isSubmit) {
          return;
        }
        this.isSubmit = true;
        var data = {};
        data.amount = this.saveParams.amount;
        if (this.withdrawType === "alipay") {
          if (this.saveParams.alipayAccount == "") {
            this.$message("支付宝账号不能为空！");
            this.isSubmit = false;
            return;
          }
          data.withdrawMode = "01";
          data.account = this.saveParams.alipayAccount;
        } else {
          if (!this.saveParams.bankName) {
            this.$message("请输入银行名称！");
            this.isSubmit = false;
            return false;
          }
          if (!this.saveParams.bankAccount) {
            this.$message("请输入银行卡号！");
            this.isSubmit = false;
            return false;
          }
          data.withdrawMode = "02";
          data.account = this.saveParams.bankAccount;
          data.bankName = this.saveParams.bankName;
        }
        if (this.saveParams.amount == "") {
          this.$message("请输入提现金额！");
          this.isSubmit = false;
          return;
        }
        var amount = parseFloat(this.saveParams.amount);
        var balance = parseFloat(this.user.balance);
        if (amount > balance) {
          this.$message("提现金额不能大于账户余额！");
          this.isSubmit = false;
          return;
        }

        let response = await saveWithdraw(data);
        if (response.code === 200) {
          // this.handleWidthDrawTypeChange()
          this.msgSuccess("提现申请已提交");
          let result = await getUserProfile({});
          this.user = result.user;
          this.user.balance = this.user.balance.toFixed(2);
          this.isSubmit = false;

          this.loadList();
        } else {
          this.msgError("提现申请提交失败!");
        }
      } catch (error) {
      } finally {
        // this.isSubmit = false
      }
    },
    //全部提现
    choiceAll() {
      if (this.user.balance > 0) {
        this.saveParams.amount = this.user.balance;
      } else {
        this.$message("账户余额为零，无法提现！");
      }
    },
    // 当提现类型改变时置空另一个类型的值
    handleWidthDrawTypeChange(type) {
      // delete this.saveParams.amount
      // delete this.saveParams.bankName
      // delete this.saveParams.bankAccount
      // delete this.saveParams.alipayAccount
    },
  },
};
</script>

<style scope>
@import "../../../assets/css/iconfont/iconfont.css";

.create_role_form {
  margin: 15px 15px 0 15px;
}
.create_role_form .el-form-item {
  display: flex;
  margin-bottom: 15px !important;
}
.create_role_form .el-form-item .el-form-item__label {
  width: 100px;
  font-weight: 700;
}
.create_role_form .el-form-item .el-form-item__content {
  width: calc(100% - 100px);
}
.withdrawal {
  margin: 8px 0 0 0;
}
.withdrawal .title {
  font-size: 17px;
  font-weight: bold;
}
.withdrawal .message {
  background-color: white;
  padding: 10px;
  border: 1px solid #dcdcdc;
  margin: 0 15px;
  line-height: 30px;
}

.withdrawal .icon {
  font-size: 18px;
  margin-left: 5px;
}

.withdrawal .el-table--border td {
  border-right: 0 solid !important;
}

.withdrawal .el-input.is-disabled .el-input__inner {
  color: black;
}
</style>
